var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon",class:'icon--' + _vm.type},[_c('img',{attrs:{"src":require('@/assets/icons/icon-' + _vm.icon + '.svg'),"alt":"icon"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }